import { createContext, useContext, useState, ReactNode } from 'react';

interface OnboardingData {
  role?: 'creator' | 'developer' | 'business';
  useCases?: string[];
  selectedTemplate?: string;
  selectedTemplateData?: any; // Store full template object
  workspaceName?: string;
  inviteTeammates?: boolean;
  createdProject?: any;
}

interface OnboardingContextType {
  data: OnboardingData;
  updateData: (newData: Partial<OnboardingData>) => void;
  currentStep: number;
  setCurrentStep: (step: number) => void;
  totalSteps: number;
  navigateToApp: () => void;
}

const OnboardingContext = createContext<OnboardingContextType | undefined>(undefined);

export function OnboardingProvider({ children }: { children: ReactNode }) {
  const [data, setData] = useState<OnboardingData>({});
  const [currentStep, setCurrentStep] = useState(0);
  const totalSteps = 3;

  const updateData = (newData: Partial<OnboardingData>) => {
    setData((prev) => ({ ...prev, ...newData }));
  };

  const navigateToApp = () => {
    // Navigate to main app - you can customize this based on your routing
    window.location.href = '/app/projects';
  };

  return (
    <OnboardingContext.Provider
      value={{
        data,
        updateData,
        currentStep,
        setCurrentStep,
        totalSteps,
        navigateToApp,
      }}
    >
      {children}
    </OnboardingContext.Provider>
  );
}

export function useOnboarding() {
  const context = useContext(OnboardingContext);
  if (context === undefined) {
    throw new Error('useOnboarding must be used within an OnboardingProvider');
  }
  return context;
}
